// Единый реестр виджетов панели оператора — используется и панелью, и меню
// настроек (список галочек «что отображать»). key совпадает с ключом
// сворачивания/видимости.
/**
 * Виджеты в порядке пользователя (store.widgets.widgetsOrder); неизвестные/новые ключи — в конце в порядке реестра
 */
export const sortWidgetDefs = (order) => {
  const idx = (k) => {
    const i = (order || []).indexOf(k);
    return i === -1 ? 1000 + WIDGET_DEFS.findIndex((w) => w.key === k) : i;
  };
  return WIDGET_DEFS.slice().sort((a, b) => idx(a.key) - idx(b.key));
};

export const WIDGET_DEFS = [
  { key: 'calls', label: 'Вызовы' },
  { key: 'alarms', label: 'Тревоги' },
  { key: 'grz', label: 'Контроль ГРЗ', grzOnly: true },
  { key: 'summary', label: 'Сводка по объекту' },
  { key: 'occ', label: 'Занятость по зонам' },
  { key: 'health', label: 'Здоровье оборудования' },
];
